import { event } from 'vue-gtag';

export type SortDirection = 'ascending' | 'descending';
export type PolicySortTableMode = 'consolidated' | 'standard';

/**
 * GA4 event for a user-initiated sort on the Policy Details page.
 *
 * `sort_field`, `sort_direction`, and `table_mode` must be registered as
 * event-scoped custom dimensions in the GA4 property before they appear in
 * reports. Fires only for explicit user interactions — never for the default
 * sort applied on page load.
 */
export function trackPolicyDetailsSort(sortField: string, sortDirection: SortDirection, tableMode: PolicySortTableMode): void {
  event('policy_details_sort', {
    sort_field: sortField,
    sort_direction: sortDirection,
    table_mode: tableMode,
  });
}
